<template>
    <div
        class="sp-coming-soon-panel"
        :class="{
            'sp-coming-soon-panel--compact': compact,
            'sp-coming-soon-panel--feedback': allowFeedback,
        }"
    >
        <div class="sp-coming-soon-panel__veil" aria-hidden="true"></div>
        <div class="sp-coming-soon-panel__content">
            <div class="sp-coming-soon-panel__icon" aria-hidden="true">
                <slot name="icon">
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </slot>
            </div>
            <p class="sp-coming-soon-panel__eyebrow">{{ eyebrow }}</p>
            <h3 class="sp-coming-soon-panel__title">{{ title }}</h3>
            <p class="sp-coming-soon-panel__copy">{{ copy }}</p>
            <StatePortalComingSoonInterest
                :key="`panel-interest-${featureKey || title}`"
                :feature-key="featureKey"
                :feature-label="resolvedFeatureLabel"
                :surface="surface"
                :allow-feedback="allowFeedback"
            />
        </div>
    </div>
</template>

<script>
import StatePortalComingSoonInterest from '@/components/Instructor/StatePortal/StatePortalComingSoonInterest.vue';

export default {
    name: 'StatePortalComingSoonPanel',
    components: {
        StatePortalComingSoonInterest,
    },
    props: {
        eyebrow: {
            type: String,
            default: 'State Portal',
        },
        title: {
            type: String,
            default: 'Coming soon',
        },
        copy: {
            type: String,
            default: 'This section isn’t available yet.',
        },
        compact: {
            type: Boolean,
            default: false,
        },
        featureKey: {
            type: String,
            default: '',
        },
        featureLabel: {
            type: String,
            default: '',
        },
        surface: {
            type: String,
            default: 'state-portal-coming-soon',
        },
        allowFeedback: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        resolvedFeatureLabel() {
            return String(this.featureLabel || this.eyebrow || this.title || '').trim();
        },
    },
};
</script>

<style scoped>
.sp-coming-soon-panel {
    position: relative;
    display: flex;
    min-height: 18rem;
    width: 100%;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 1rem;
    border: 1px solid rgba(226, 232, 240, 0.95);
    background:
        linear-gradient(135deg, rgba(240, 253, 250, 0.55), rgba(248, 250, 252, 0.9)),
        repeating-linear-gradient(
            -12deg,
            rgba(148, 163, 184, 0.06) 0,
            rgba(148, 163, 184, 0.06) 12px,
            transparent 12px,
            transparent 24px
        );
}

.sp-coming-soon-panel--compact {
    min-height: 14rem;
}

.sp-coming-soon-panel__veil {
    position: absolute;
    inset: 0;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.45);
}

.sp-coming-soon-panel__content {
    position: relative;
    z-index: 1;
    max-width: 22rem;
    padding: 1.5rem 1.25rem;
    text-align: center;
}

.sp-coming-soon-panel--feedback .sp-coming-soon-panel__content {
    max-width: 26rem;
}

.sp-coming-soon-panel__icon {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 0.9rem;
    color: #0f766e;
    background: linear-gradient(145deg, rgba(204, 251, 241, 0.95), rgba(255, 255, 255, 0.85));
    border: 1px solid rgba(45, 212, 191, 0.35);
    box-shadow: 0 8px 18px -12px rgba(13, 148, 136, 0.55);
}

.sp-coming-soon-panel__eyebrow {
    margin-top: 0.9rem;
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #0d9488;
}

.sp-coming-soon-panel__title {
    margin-top: 0.3rem;
    font-size: 1.25rem;
    line-height: 1.25;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #0f172a;
}

.sp-coming-soon-panel__copy {
    margin: 0.55rem auto 0;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #64748b;
}
</style>
